(function () {
  const ACCORDION_ITEM_ELEMENT_NAME = 'sb-accordion-item';
  const ACCORDION_ITEM_TOGGLE_EVENT = 'sb-accordion-item-toggle';

  if (window.AccordionModule) {
    return;
  }

  window.AccordionModule = true;

  function hasAccordions() {
    return document.querySelectorAll(ACCORDION_ITEM_ELEMENT_NAME).length > 0;
  }

  if (!hasAccordions()) {
    return;
  }

  class AccordionItemElement extends HTMLElement {
    #isOpen = false;

    constructor() {
      super();
      this.toggleVisibility = this.toggleVisibility.bind(this);
      this.updateContentHeight = this.updateContentHeight.bind(this);
      this.isOpen = false;
    }

    get isOpen() {
      return this.#isOpen;
    }

    set isOpen(value) {
      if (this.summaryElement) {
        this.summaryElement.setAttribute('aria-expanded', value);
      }
      this.#isOpen = value;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      this.detailsElement = this.querySelector('details');
      this.summaryElement = this.detailsElement.querySelector('summary');
      this.isOpen = this.detailsElement.hasAttribute('open');
      this.summaryElement.addEventListener('click', this.toggleVisibility);
      window.addEventListener('resize', this.updateContentHeight);
      this.updateContentHeight();
      this.detailsElement.classList.add('js-accordion-item-details');
    }

    destroy() {
      this.summaryElement.removeEventListener('click', this.toggleVisibility);
      window.removeEventListener('resize', this.updateContentHeight);
    }

    toggleVisibility(event) {
      if (!this.isOpen) {
        this.open();
      } else {
        event.preventDefault();
        this.close();
      }
    }

    open() {
      this.isOpen = true;
      // setTimeout is needed to allow the open attribute to be set before calculating scrollHeight
      setTimeout(this.updateContentHeight, 0);

      this.dispatchToggleEvent();
    }

    close() {
      this.isOpen = false;
      this.updateContentHeight();

      this.detailsElement.addEventListener(
        'transitionend',
        () => {
          // this.detailsElement.style.overflow = 'visible';
          this.detailsElement.removeAttribute('open');
        },
        { once: true }
      );

      this.dispatchToggleEvent();
    }

    dispatchToggleEvent() {
      const toggleEvent = new CustomEvent(ACCORDION_ITEM_TOGGLE_EVENT, {
        bubbles: true,
        detail: { item: this },
      });
      this.dispatchEvent(toggleEvent);
    }

    updateContentHeight() {
      if (!this.isOpen) {
        this.detailsElement.style.height = this.summaryElement.getBoundingClientRect().height + 'px';
        return;
      }
      const children = Array.from(this.detailsElement.children);
      this.detailsElement.style.height = children.reduce((acc, child) => acc + this.getOuterHeight(child), 0) + 'px';
    }

    getOuterHeight(el) {
      const style = getComputedStyle(el);

      return el.getBoundingClientRect().height + parseFloat(style.marginTop) + parseFloat(style.marginBottom);
    }
  }

  customElements.define(ACCORDION_ITEM_ELEMENT_NAME, AccordionItemElement);
})();
